import React, { useState } from 'react';
import { validateAndUpdatePhoneNumbers } from '../../utils/phoneUtils';
import './TestingPanel.css';

const TestingPanel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTest, setActiveTest] = useState(null);

  const tests = [
    {
      id: 'phone-numbers',
      name: 'Phone Numbers Validation',
      description: 'Test and validate all service provider phone numbers',
      action: validateAndUpdatePhoneNumbers
    },
    // Add more tests here as needed
  ];

  const runTest = async (test) => {
    setIsLoading(true);
    setActiveTest(test.id);
    try {
      const results = await test.action();
      displayResults(results, test.id);
    } catch (error) {
      console.error(`Test failed: ${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const displayResults = (results, testId) => {
    const resultsContainer = document.getElementById(`${testId}-results`);
    if (!resultsContainer) return;

    switch (testId) {
      case 'phone-numbers':
        resultsContainer.innerHTML = `
          <div class="test-results">
            <div class="results-header">
              <h4>Test Results</h4>
              <span class="timestamp">${new Date().toLocaleString()}</span>
            </div>
            <div class="results-grid">
              <div class="result-item">
                <span class="label">Total Providers:</span>
                <span class="value">${results.total}</span>
              </div>
              <div class="result-item">
                <span class="label">Valid Numbers:</span>
                <span class="value success">${results.valid}</span>
              </div>
              <div class="result-item">
                <span class="label">Invalid Numbers:</span>
                <span class="value error">${results.invalid.length}</span>
              </div>
              <div class="result-item">
                <span class="label">Updated Numbers:</span>
                <span class="value info">${results.updated}</span>
              </div>
            </div>
            ${results.invalid.length > 0 ? `
              <div class="invalid-items">
                <h5>Invalid Numbers Found:</h5>
                <ul>
                  ${results.invalid.map(item => `
                    <li>
                      <strong>${item.providerName}</strong>: ${item.originalNumber}
                    </li>
                  `).join('')}
                </ul>
              </div>
            ` : ''}
          </div>
        `;
        break;
      // Add more test result displays as needed
    }
  };

  return (
    <div className="testing-panel">
      <h2>Testing Panel</h2>
      <div className="tests-container">
        {tests.map(test => (
          <div key={test.id} className="test-card">
            <h3>{test.name}</h3>
            <p>{test.description}</p>
            <button 
              onClick={() => runTest(test)}
              disabled={isLoading && activeTest === test.id}
              className="run-test-btn"
            >
              {isLoading && activeTest === test.id ? 'Running...' : 'Run Test'}
            </button>
            <div id={`${test.id}-results`} className="results-container"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestingPanel; 